import autosize from 'autosize';
import {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';

export const useAutosize = (data: {
    disabled: boolean;
    name: string;
    ref: React.RefObject<HTMLElement>;
}) => {
    const {watch} = useFormContext();
    const watchValue = watch(data.name);
    useEffect(() => {
        if (!data.disabled && data.ref.current) {
            const event = new Event('input', {bubbles: true});
            data.ref.current.dispatchEvent(event);
        }
    }, [watchValue]);
    useEffect(() => {
        if (!data.disabled && data.ref.current) {
            autosize(data.ref.current);
        }
    }, [data.ref.current]);
};
